import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { DataService } from '../../services/data.service';
import { LoaderService } from '../../services/loader/loader.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {


  loginForm = this.fb.group({
    username: ['', [Validators.required]],
    password: ['', [Validators.required, Validators.maxLength(10)]]
  });

  errMessage = 'This field shouldn\'t be empty *';
  submitted = false;
  passwordHide = true;
  loginError = false;

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<LoginComponent>,
    public router: Router,
    // private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data, private fb: FormBuilder, public serviceData: DataService, public loaderService: LoaderService) { }

  ngOnInit(): void {
  }

  get fcontrol() { return this.loginForm.controls; };

  Login() {
    this.submitted = true;
    this.loginForm.markAllAsTouched();
    if (this.loginForm.status === 'VALID') {
      this.loaderService.display(true);
      let data = {
        "username": this.loginForm.controls.username.value,
        "password": this.loginForm.controls.password.value
      }
      this.serviceData.login(data).subscribe((resp: any) => {
        if (resp.success) {
          this.loaderService.display(false);
          this.saveData(resp.data);
          this.dialogRef.close('success')
        }
      }, Error => {
        this.loaderService.display(false);
        console.log('Err is ', Error);
        this.loginError = true;
        // this.loginForm.controls['username'].setErrors({ 'incorrect': true });
        // this.loginForm.controls['password'].setErrors({ 'incorrect': true });
      });
    }
  }

  close() {
    this.dialogRef.close()
  }

  saveData(data) {
    localStorage.setItem('isUserLoggedin', 'true');
    localStorage.setItem('userData', JSON.stringify(data));
  }

  // goto signup window
  gotoSignup() {
    this.dialogRef.close('signup')
  }

}
